var Env = require('./env');

var reqDomains = {
  dev: 'http://localhost:8081/',
  test: 'http://www.chubbyface.top/',
  // pro: 'http://nb.newbao.com.cn/',
  pro: 'http://new.ynyzxjy.cn/',
};

var httpRoots = {
  dev: 'http://localhost:8081/newBaoPublic/',
  test: 'http://www.chubbyface.top/newBaoPublic/',
  // pro: 'http://nb.newbao.com.cn/newBaoPublic/',
  pro: 'http://new.ynyzxjy.cn/newBaoPublic/',
};

function parse (config) {
  switch (Env.env) {
    case 'production':
      return config.pro;
    case 'test':
      return config.test;
    default:
      return config.dev;
  }
}

module.exports = {
  reqDomains () {
    return parse(reqDomains);
  },
  httpRoot () {
    return parse(httpRoots);
  },
};



// WEBPACK FOOTER //
// ./config/config.js